import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Portal component that renders children to document.body
 * This ensures modals/overlays are rendered outside of any parent
 * stacking contexts, overflow containers, or transform elements.
 * 
 * Usage:
 * <Portal>
 *   <div className="modal-overlay">...</div>
 * </Portal>
 */
const Portal = ({ children }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  // Only render portal after component mounts (client-side)
  // This prevents SSR hydration mismatches
  if (!mounted) return null;

  return createPortal(children, document.body);
};

export default Portal;

